<template>
  <p class="submit-button-text">
    {{ $t('messages_nl.search.show') }} {{ addDotsInNumber(houseCountVariable) }} {{ resultsName(houseCountVariable) }}
  </p>
</template>

<script>
import shared from '../../../../../common/vue/components/search/text/shared';

export default {
  name: "adivare-text-submit-button",
  props: {
    countExpected: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  extends: shared,
  computed: {
    houseCountVariable() {
      if (true === this.countExpected && undefined !== this.houseCountExpected) {
        return this.houseCountExpected;
      } else {
        return this.houseCount;
      }
    }
  }
}
</script>
